import React, { useEffect, useState } from "react";
import "./styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { base_url } from "../api/api-url";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Slide from "@mui/material/Slide";
import logo from '../img/logo.png';
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { encryptText } from "../utility/cryptoUtils";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("user"); // NEW: Role state
  const [errors, setErrors] = useState({});
  const [formError, setFormError] = useState("");
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");
  const [step, setStep] = useState(1);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) newErrors.email = "Email is required";
    else if (!emailRegex.test(email)) newErrors.email = "Invalid email format";

    if (!password) newErrors.password = "Password is required";
    else if (password.length < 6)
      newErrors.password = "Password must be at least 6 characters";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };
  const handleClose1 = (_, reason) => {
    if (reason === "clickaway") return;
    setOpen1(false);
  };
useEffect(()=>{
  localStorage.setItem("importedOldData",false)
},[])
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError("");

    if (validateForm()) {
      try {
        const response = await fetch(`${base_url}/user-login`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password, role }), // include role if required
        });

        const data = await response.json();

        if (response.ok) {
          localStorage.setItem("authToken", data.token);
          localStorage.setItem("user_name", data.data.name);
          localStorage.setItem("email", encryptText(email));
          localStorage.setItem("role", encryptText(data.data.role));
          console.log("allowedModule from login response:", data.data.allowedModule);
          localStorage.setItem("allowedModule", encryptText(JSON.stringify(data.data.allowedModule)));
          // console.log(data.data.department[0].label)
          if(data.data.department[0]){
                  localStorage.setItem("department",encryptText(data.data.department[0].label))
          }
    

          setOpen(true);
          navigate("/dashboard");
        } else {
          setFormError(data.message || "Invalid email or password");
          setOpen1(true);
        }
      } catch (error) {
        console.error("Login Error:", error);
        setFormError("Something went wrong. Please try again.");
        setOpen1(true);
      }
    }
  };

  const handleSendOTP = async () => {
    setError("");
    if (!email || !email.includes("@")) {
      setError("Please enter a valid email");
      return;
    }

    try {
      const res = await fetch(`${base_url}/user-resetPassword`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (res.ok) setStep(2);
      else setError("Please enter the valid mail Id");
    } catch {
      setError("Network error. Try again later.");
    }
  };

  const handleVerifyOTP = async () => {
    setError("");
    if (!otp || !newPassword) {
      setError("All fields are required");
      return;
    }

    try {
      const res = await fetch(`${base_url}/user-verifyOtp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp, newPassword }),
      });

      if (res.ok) {
        alert("Password reset successful!");
        handleClose2();
        resetFields();
      } else setError("Invalid OTP or email");
    } catch {
      setError("Network error. Try again later.");
    }
  };

  const resetFields = () => {
    setStep(1);
    setEmail("");
    setOtp("");
    setNewPassword("");
    setError("");
  };

  return (
    <React.Fragment>
      <div className="login-bg">
        <div className="login-container">
          <div className="login-form-container">
            <div className="d-flex justify-content-center">
              <img src={logo} alt="Hogist" style={{ width: "60%", marginBottom: "2%" }} />
            </div>
            <h2 className="login-sub-header">Customer Support CRM</h2>

            <form onSubmit={handleSubmit} className="login-form">
            
              <div className="input-group">
                <label className="input-label">Email Address</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={`input-field ${errors.email ? "input-error" : ""}`}
                  placeholder="admin@example.com"
                />
                {errors.email && <div className="error-text">{errors.email}</div>}
              </div>

              <div className="input-group password-container">
                <label className="input-label">Password</label>
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className={`input-password input-field ${errors.password ? "input-error" : ""}`}
                  placeholder="••••••••"
                />
                <span
                  style={{ top: errors.password ? "35%" : "50%" }}
                  className="toggle-visibility"
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {!showPassword ? <VisibilityOff sx={{ color: "white" }} /> : <Visibility sx={{ color: "white" }} />}
                </span>
                {errors.password && <div className="error-text">{errors.password}</div>}
              </div>

            

              <button type="submit" className="login-button">
                Sign In
              </button>
            </form>

            <div className="forget-credentials" onClick={handleClickOpen}>
              Forget Password
            </div>
          </div>

          <div className="footer-text">
              <p>© 2025 Hogist Technologies Pvt. Ltd. All rights reserved. | CRM v3.0</p>
          </div>
        </div>

        <Snackbar open={open} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={3000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="success" variant="filled" sx={{ width: "100%" }}>
            Login successful!
          </Alert>
        </Snackbar>

        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={open1} autoHideDuration={3000} onClose={handleClose1}>
          <Alert onClose={handleClose1} severity="warning" variant="filled" sx={{ width: "100%" }}>
            Invalid email or password!
          </Alert>
        </Snackbar>

        {/* Password Reset Dialog */}
        <Dialog
          fullScreen={fullScreen}
          open={open2}
          onClose={() => {
            handleClose2();
            resetFields();
          }}
          TransitionComponent={Transition}
          keepMounted
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            sx: {
              width: fullScreen ? "100%" : "500px",
              height: fullScreen ? "100%" : "auto",
              padding: 4,
              borderRadius: 3,
            },
          }}
        >
          <DialogTitle id="responsive-dialog-title">
            {step === 1 ? "Please Enter Your Mail ID" : "Verify OTP and Set New Password"}
          </DialogTitle>

          <DialogContent>
            {error && <p style={{ color: "red" }}>{error}</p>}

            {step === 1 ? (
              <TextField
                autoFocus
                required
                margin="dense"
                id="email"
                name="email"
                label="Email Address"
                type="email"
                fullWidth
                variant="standard"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            ) : (
              <>
                <TextField margin="dense" label="Email" type="email" fullWidth variant="standard" value={email} disabled />
                <TextField margin="dense" label="OTP" fullWidth variant="standard" value={otp} onChange={(e) => setOtp(e.target.value)} />
                <TextField
                  margin="dense"
                  label="New Password"
                  type="password"
                  fullWidth
                  variant="standard"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </>
            )}
          </DialogContent>

          <DialogActions>
            <Button onClick={() => {
              handleClose2();
              resetFields();
            }}>
              Cancel
            </Button>
            {step === 1 ? (
              <Button onClick={handleSendOTP}>Send OTP</Button>
            ) : (
              <Button onClick={handleVerifyOTP}>Reset Password</Button>
            )}
          </DialogActions>
        </Dialog>
      </div>
    </React.Fragment>
  );
};

export default Login;
